/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnalyticFilterDefinition } from './analyticFilterDefinition';


/**
 * Entry table for filtering. Corresponds to a filter type (slider, dropdown, search, free text field, etc.). A one_to_many mapping is necessary for AnalyticFilterDefinition.
 */
export interface AnalyticFiltertype { 
    /**
     * Internal AnalyticFilterType Key
     */
    id?: number;
    /**
     * Filter name
     */
    filterName?: string;
    /**
     * Control type
     */
    controlType?: string;
    /**
     * Multi-flag
     */
    multi?: number;
    /**
     * Min-Max flag
     */
    minMax?: number;
    /**
     * Description
     */
    description?: string;
    /**
     * Start value for numeric filter
     */
    startwertNum?: number;
    /**
     * Start value for character filter
     */
    startwertChar?: string;
    /**
     * Placeholder
     */
    placeHolder?: string;
    /**
     * Validators
     */
    validatoren?: number;
    /**
     * Minimum characters
     */
    minChars?: number;
    /**
     * SkipAll flag
     */
    skipAll?: number;
    analyticFilterDefinition?: Array<AnalyticFilterDefinition>;
}

